.page {
  position: relative;
  min-height: 100%;
  display: grid;
  place-items: center;
  padding: 32px 16px;
  isolation: isolate;
}

.panel {
  position: relative;
  width: min(480px, 100%);
  padding: 36px 32px 32px;
  border-radius: var(--radius-large);
  background: linear-gradient(160deg, rgb(255 255 255 / 0.09), rgb(255 255 255 / 0.03));
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-panel);
  backdrop-filter: blur(18px);
  display: grid;
  gap: 28px;
}

.header {
  text-align: center;
  display: grid;
  gap: 6px;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-size: clamp(2.2rem, 7vw, 3rem);
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1;
}

.title span {
  color: var(--color-accent);
  font-style: italic;
  margin: 0 0.06em;
  text-shadow: 0 0 24px rgb(232 184 79 / 0.45);
}

.tagline {
  margin: 0;
  color: var(--color-text-muted);
}

.actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 420px) {
  .panel {
    padding: 28px 20px 24px;
  }

  .actions {
    grid-template-columns: 1fr;
  }
}
